import { FC } from 'react'
import IconPushAPI from 'assets/images/icon-pushapi.svg'
import IconShopify from 'assets/images/icon-shopify.svg'
import Iconwoocommerce from 'assets/images/icon-woocommerce.svg'
import starshipitIcon from 'assets/images/starshipitIcon.svg'
import wixIcon from 'assets/images/wix.svg'

import { OrderStatusLabel } from 'components/atoms/OrderStatusLabel'
import { OrderTypeLabel } from 'components/atoms/OrderTypeLabel'
import { dateToAEST } from 'utils'
import { capitalizeFirstLetter } from 'utils/capitalizeFirstLetter'

export interface OrderHeaderProps {
  [x: string]: any
}

/** This is OrderHeader */

export const OrderHeader: FC<OrderHeaderProps> = ({
  orderDetails,
}: OrderHeaderProps) => {
  return (
    <div className='header_container flex flex-col w-full pb-3 px-4 pt-4 border-b border-b-N-200 sticky top-0 bg-white z-[1]'>
      <div className='flex items-center justify-between w-full'>
        {/* Left Side - Order Info and Integration Type */}
        <div className='flex items-center space-x-2'>
          {/* Order Info */}
          <p className='text-lg font-semibold text-black'>
            Order Info - {orderDetails?.customerOrderNo}
          </p>

          {/* Order Status */}
          <OrderStatusLabel
            appearance={capitalizeFirstLetter(orderDetails?.status || '')}
            labelValue={capitalizeFirstLetter(orderDetails?.status || '')}
          />

          {/* Order Type */}
          {orderDetails?.orderType && (
            <OrderTypeLabel labelValue={orderDetails?.orderType} />
          )}

          {/* Integration Type Icons */}
          {orderDetails?.integrationType === 'Woocommerce' && (
            <img
              src={Iconwoocommerce}
              alt='Woocommerce Icon'
              className='pl-2'
            />
          )}
          {orderDetails?.integrationType === 'Shopify' && (
            <img src={IconShopify} alt='Shopify Icon' className='pl-2' />
          )}
          {orderDetails?.integrationType === 'PushApi' && (
            <img src={IconPushAPI} alt='PushAPI Icon' className='pl-2' />
          )}
          {orderDetails?.integrationType === 'IcsWMS' && (
            <i className='ri-store-3-fill text-xl text-N-600'></i>
          )}
          {orderDetails?.integrationType === 'AzureSftp' && (
            <i className='ri-folder-received-fill text-xl text-N-600'></i>
          )}
          {orderDetails?.integrationType === 'StarshipIT' && (
            <img src={starshipitIcon} alt='StarshipIT Icon' className='pl-2' />
          )}

          {/* Additional Meta Icon for Wix */}
          {orderDetails?.integrationType === 'StarshipIT' &&
            orderDetails?.meta === 'Wix' && (
              <div className='flex items-center pl-1'>
                <span>-</span>
                <img src={wixIcon} alt='Wix Icon' className='pl-1' />
              </div>
            )}
        </div>

        {/* Right Side - Created Date */}
        <div className='flex items-center space-x-1'>
          <i className='ri-calendar-event-line text-sm'></i>
          <p className='text-xs font-medium text-N-500'>
            {dateToAEST(orderDetails?.createdOn)}
          </p>
        </div>
      </div>

      <div className='flex w-full items-center pt-1 text-xs font-medium text-N-500 gap-x-3 divide-x divide-N-500'>
        <p>WMS Order #: {orderDetails?.warehouseOrder?.orderNo || '-'}</p>

        <p className='pl-3'>
          Customer Reference: {orderDetails?.customerReferance || '-'}
        </p>

        <p className='pl-3'>
          {orderDetails?.partner?.code} - {orderDetails?.partner?.name}
        </p>

        {orderDetails?.partner?.code === '42167' && (
          <p className='pl-3'>Customer PO #: {orderDetails?.meta || '-'}</p>
        )}
      </div>
    </div>
  )
}

OrderHeader.defaultProps = {}

export default OrderHeader
